
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BrowserInfo } from '@core/models/browser-info.model';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/services/alert.service';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-report-problem-modal',
  templateUrl: './report-problem-modal.component.html',
  styleUrls: ['./report-problem-modal.component.scss']
})
export class ReportProblemModalComponent implements OnInit {
  formReportProblem: UntypedFormGroup = this.fb.group({
    subject: ['', Validators.compose([
      Validators.required,
      Validators.maxLength(250)
    ])],
    message: ['', Validators.compose([
      Validators.required,
      Validators.maxLength(2000)
    ])]
  });

  loading: boolean = false;
  extensions = ".jpg,.jpeg,.gif,.png";
  droppedFiles: any[] = [];


  constructor(
    protected dialogRef: NbDialogRef<ReportProblemModalComponent>,
    private api: ApiService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  overrideDefault(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  getFormControl(name: string): UntypedFormControl {
    return this.formReportProblem.get(name) as UntypedFormControl;
  }

  hasError(name: string): boolean {
    var e = this.getFormControl(name);
    return e.touched && !e.valid;
  }

  uploadFile(event: any) {
    this.droppedFiles = event.target.files || event.dataTransfer.files;
    const extensionsArray = this.extensions.split(",");

    for (let i = 0; i < this.droppedFiles.length; i++) {
      let correctExtension = false;
      for (let j = 0; j < extensionsArray.length; j++) {
        if (this.fileExtension(this.droppedFiles[i].name).toLowerCase() === extensionsArray[j]) {
          correctExtension = true;
          break;
        }
      }

      if (!correctExtension) {
        this.alertService.danger(
          "alerts.incorrect-file-extension-reported-problem",
          5000);
        this.droppedFiles = [];
      }
    }
  }

  reportProblem(): void {
    this.loading = true;

    const formData = new FormData();
    formData.append('subject', this.formReportProblem.value.subject);
    formData.append('message', this.formReportProblem.value.message);
    formData.append('browserInfo', JSON.stringify(this.getBrowserInfo()));

    for (let i = 0; i < this.droppedFiles.length; i++) {
      formData.append('files', this.droppedFiles[i]);
    }

    this.api.postReportProblem(formData).subscribe(() => {
      this.loading = false;
      this.dialogRef.close();
      this.alertService.success( 'alerts.report-problem-success', 3000);
    }, err => {
      this.loading = false;
      this.formReportProblem.setErrors({
        "error": this.translate.instant(`errors.${err.error}`)
      });
    });
  }

  getBrowserInfo(): BrowserInfo {
    return new BrowserInfo({
      codeName: navigator.appCodeName,
      name: navigator.appName,
      cookiesEnabled: navigator.cookieEnabled,
      fullVersion: navigator.appVersion,
      language: navigator.language,
      platform: navigator.platform,
      userAgentHeaders: navigator.userAgent
    });
  }

  private fileExtension(fileName: string): string {
    let fileExtension: string;
    let index = fileName.lastIndexOf(".");
    if (index > 0) {
      fileExtension = fileName.substring(index, fileName.length);
      return fileExtension;
    }
    return "";
  }

}
